var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-base-root-container"},[_c('div',{staticClass:"project-base-image",style:({
      'background-image':
        'url(' +
        (_vm.baseInfo.img_url ? _vm.baseInfo.img_url : _vm.icons.employerAvatar) +
        ')',
    })}),_c('span',{staticClass:"project-base-name",on:{"click":_vm.jumpCompanyDetail}},[_vm._v("项目所有者："+_vm._s(_vm.baseInfo.name))]),_c('div',{staticClass:"project-base-desc-container"},[_vm._v(" 暂无描述 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }